import { FC } from "react";

import {
  EditGridColumnButton,
  PanelTopRightWrapperStyled,
  PanelTopStatBookings,
} from "@ryde/layout";
import { useIsMobile } from "@ryde/shared";

import { ViewSwitchBookings } from "./view-switch.bookings";

export const PanelTopRightBookings: FC = () => {
  const { isMobile } = useIsMobile();
  return (
    <PanelTopRightWrapperStyled>
      <PanelTopStatBookings />
      <ViewSwitchBookings />
      {!isMobile && <EditGridColumnButton />}
    </PanelTopRightWrapperStyled>
  );
};
